module.exports = "<p>בקלות רבה. לאחר שהתחברתם לאתר, תוכלו ללחוץ על לחצן החשבון שבחלקו העליון של עמוד הבית ולבחור בניהול נכסים. לחצו על לחצן העריכה ומשם הדרך כבר קצרה :) אל תשכחו לשמור את השינויים על ידי לחצן העדכון נכס שבתחתית העמוד.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/5.md
// module id = 812
// module chunks = 0